<template>
  <v-sheet class="pa-2" border elevation="0">
    <div class="text-h6">Transactions</div>
    <div class="d-flex flex-column sm-gap" v-for="transaction in transactions" :key="transaction.id">
      <div class="d-flex gap align-center">
        <v-chip v-if="transaction.statut == 'PAID'" color="green-darken-4">{{ transaction.statut }}</v-chip>
        <v-chip v-else color="deep-orange-darken-4">{{ transaction.statut }}</v-chip>
        <div>
          <b>{{ transaction.prix }}€</b> | {{ transaction.uuid }} | {{ transaction.timestamp }}
        </div>
        <hr />
      </div>
    </div>
  </v-sheet>
</template>

<script>
export default {
  props: ["transactions"],
};
</script>

<style lang="scss" scoped>
</style>